/**
 * The version of the NPM package.
 *
 * Webpack replaces any instances of this constant with a hard-coded string at build time.
 */
declare const PACKAGE_VERSION: string;

export function getVersion(): string {
  return PACKAGE_VERSION;
}

const TEMPLATE_API_VERSION = '1';

export function getTemplateAPIVersion(): string {
  return TEMPLATE_API_VERSION;
}
